import React, {useState, useEffect} from 'react';
import ReactDom from 'react-dom';
import {MDBBtn, MDBContainer, MDBIcon, MDBRow } from "mdbreact";
import axios from 'axios';


//**************************** CSS
import './index.css';
//**************************** CSS mdbreact
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbreact/dist/css/mdb.css';

//**************************** components
import Movie from './components/Movie';
import Title from './components/Title';
import SearchBar from './components/SearchBar';

//**************************** movie data
//import { movies } from './movies';//export named >> export const movies
const url = 'https://davidpadua.com/json/movies-videoteca.json';



function MovieList() {

      const [videos, setVideos] = useState([]);
      const [loading, setLoading] = useState(true);
      const [toggleAlphabetic, setToggleAlphabetic] = useState(true);
      const [sortAscending, setSortAscending] = useState(true);

      const getVideos = async () => {
        //const response = await fetch(url).then((response) => response.json());
        //const videos = await response.json();
        //console.log(videos);

        try {
            setLoading(true);
            const response = await axios.get(url);
            const videos = response.data;

            setVideos(videos);
            setSearchResults(videos);

            setLoading(false);

          } catch(error){
            
            console.log(error);
            setLoading(true);
          }
        
      };

      //::: state actualizado sempre que escrevemos no input search
      const [searchTerm, setSearchTerm] = useState('');
      
      //::: array de valores state definido no useEffect 
      const [searchResults, setSearchResults] = useState([]);

      //::: click que actualiza o valor searchTerm do input no state
      const handleChange = event => {
          setSearchTerm(event.target.value);
        };

      //::: scroll function to move movies list top top when search by type
      const scrollMoviesTop = (topOffset) => {
        const id = 'moviesList';
        const yOffset = topOffset; 
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
      }
      //::: order list alhpabetical
      const orderListAlphabetical = (ascDesc) => {
        let copyOfMovies = [...videos];
        setToggleAlphabetic(ascDesc);

        if(toggleAlphabetic) {
          setVideos(copyOfMovies.sort((a, b) => a.title.localeCompare(b.title)));
        } else {
          setVideos(copyOfMovies.sort((a, b) => b.title.localeCompare(a.title)));
        }
        

        scrollMoviesTop(-220);
        
      };

      //::: order list by year
      const orderListByType = (type) => {
        let copyOfMovies = [...videos];

        sortAscending 
        ? 
          setVideos( copyOfMovies.sort((a, b) => (b[type] > a[type]) ? 1 : ((a[type] > b[type]) ? -1 : 0)) ) 
        : 
          setVideos( copyOfMovies.sort((a, b) => (a[type] > b[type]) ? 1 : ((b[type] > a[type]) ? -1 : 0)) ) 
        

        scrollMoviesTop(-220);
      };
      //::: useEffect hook que corre sempre que o searchTerm stat é actualizado
      //::: que por sua vez actualiza o state array (searchResults) de valores com um novo array searchTerm
      //::: que depois é chamado pelo map dentro da <section> mais em baixo
      useEffect(() => {
            getVideos();
      }, []);

      useEffect(() => {
          const results = videos.filter(movieItem => 
            movieItem.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
            movieItem.director.toLowerCase().includes(searchTerm.toLowerCase()) ||
            movieItem.cast.toLowerCase().includes(searchTerm.toLowerCase()) 

       );
        setSearchResults(results);
      }, [searchTerm, videos]);
       
        
  return (

    <React.StrictMode>
      <MDBContainer fluid>
              <Title videos={videos} />
              <SearchBar sortAscending={sortAscending} setSortAscending={setSortAscending} toggleAlphabetic={toggleAlphabetic} searchTerm={searchTerm} handleChange={handleChange} setSearchTerm={setSearchTerm} orderListAlphabetical={orderListAlphabetical} orderListByType={orderListByType} />
              <MDBRow id="moviesList" className='movies-list d-flex justify-content-center align-items-center mb-3'>
                  {
                    loading 
                    ? 
                      <div className="spinner-loader-container d-flex justify-content-center align-items-center flex-column">
                        <div className="spinner-grow spinner-grow-lg text-warning " role="status"></div> 
                        <h4 className='font-weight-bold orange-text'>Loading...</h4>
                      </div>
                    :
                      
                        (
                          <section className="row container mb-4 d-flex justify-content-center align-items-stretch w-100">
                          
                              {searchResults.map(movieItem => (
                                <Movie key={movieItem.id} {...movieItem} searchResults={searchResults} /* ou imageURL={movieItem.imageURL} title={movieItem.title} director={movieItem.director} */ />
                              ))}

                          </section>
                    
                        )
                      
                  } 
                  {
                    !loading && searchResults.length === 0 
                    ? 
                    (
                      <h2 className="deep-orange-text">Sorry, no movies found with that search criteria.</h2>
                    ) 
                    :
                    null
                  }
              </MDBRow>
              {
                searchResults.length > 1 
                ? (
                  <MDBRow className="d-flex justify-content-center">
                    <MDBBtn className="movie-details-btn p-3"  color='info' onClick={() => scrollMoviesTop(-220)} >
                      <MDBIcon className="text-center" fas icon="arrow-up" size="2x"  />
                    </MDBBtn>
                  </MDBRow>
                ) :
                null
              }
      </MDBContainer>
    </React.StrictMode>
  
  )
}


ReactDom.render(<MovieList />, document.getElementById('root'));